// Canonical validation copy shared across web schemas, package schemas, and inline
// component validators. Consolidated by ENG-1924 so the same validation concept
// (e.g. "name has invalid characters", "handle isn't available") reads the same
// everywhere, regardless of which schema/component happens to own a given form.
//
// Which schema owns which field is documented in docs/validation-ownership.md.

// ---- Name ----
export const NAME_VALIDATION_REGEX = /^[A-Za-zÀ-ÿ' -]+$/;
export const NAME_INVALID_MESSAGE =
  "Name can only contain letters, spaces, apostrophes, and hyphens";

// ---- Email ----
export const EMAIL_INVALID_MESSAGE = "Please enter a valid email address";

// ---- Phone (10-digit strategy: register, edit-profile, checkout).
// golf-buddies and verify-phone use a separate international libphonenumber
// strategy (see apps/web/src/utils/validatePhoneNumber.ts) since they need to
// validate numbers outside the North American 10-digit format. ----
export const PHONE_10_DIGIT_REGEX = /^\d{10}$/;
export const PHONE_INVALID_MESSAGE = "Phone number must be exactly 10 digits";
export const PHONE_COUNTRY_CODE_REQUIRED_MESSAGE = "Phone number country code is required.";

// ---- Handle / username ----
export const HANDLE_NOT_ALLOWED_MESSAGE = "This handle isn't allowed";
export const HANDLE_ALREADY_TAKEN_MESSAGE = "This handle is already taken";
// Exact string the server (user.service.ts) sends when the handle-uniqueness
// check fails. Client code matches against this to route the generic
// { error, message } server response to the handle field instead of a
// page-level banner.
export const HANDLE_ALREADY_TAKEN_SERVER_MESSAGE = "Handle already exists.";

// ---- Address ----
export const ZIP_REQUIRED_MESSAGE = "Zip code is required";
